import '../app/webpack';
import * as bundle from 'bundle';

if (Playtech.Variables.isGameWrapper) {
    bundle.renderApp({ container: document.querySelector('#wrapper'), isWrapper: true });
} else {
    // @theme
    require('../app/codere-theme/app.js');
}
